import React, { Component } from 'react'
import CalendarStore from '../stores/CalendarStore'
import Scheduler from 'react-big-scheduler'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import withDragDropContext from '../utils/withDnDContext'
import CalendarEvent from '../components/Calendar/CalendarEvent'
import { Header, Modal } from 'semantic-ui-react'
import AuthenticationStore from '../stores/AuthenticationStore'
import 'react-big-scheduler/lib/css/style.css'

@withDragDropContext
@inject('authenticationStore', 'calendarStore')
@observer
class CalendarScreen extends Component {
  static propTypes = {
    authenticationStore: PropTypes.instanceOf(AuthenticationStore).isRequired,
    calendarStore: PropTypes.instanceOf(CalendarStore).isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      viewModel: props.calendarStore.schedulerData,
      isModalOpened: false,
      selectedItem: null
    }
  }

  componentDidMount () {
    this.reload()
  }

  prevClick = (schedulerData) => {
    const { calendarStore } = this.props
    schedulerData.prev()
    calendarStore.schedulerData = schedulerData
    this.reload()
  }

  reload () {
    const { calendarStore } = this.props
    calendarStore.load().then(() => {
      this.setState({ viewModel: calendarStore.schedulerData })
    })
  }

  eventDeleteFunc = (eventId) => {
    const { calendarStore } = this.props
    calendarStore.deleteEvent(eventId).then(() => {
      this.reload()
    }).catch(e => {
      console.log(e)
    })
  }

  eventConfirmFunc = (eventId) => {
    const { calendarStore } = this.props
    calendarStore.confirmEvent(eventId).then(() => {
      this.reload()
    }).catch(e => {
      console.log(e)
    })
  }

  nextClick = (schedulerData) => {
    const { calendarStore } = this.props
    schedulerData.next()
    calendarStore.schedulerData = schedulerData
    this.reload()
  }

  handleSelectDate = () => {

  }

  handleViewChange = (schedulerData, view) => {
    const { calendarStore } = this.props
    schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective)
    schedulerData.config.creatable = !view.isEventPerspective
    calendarStore.schedulerData = schedulerData
    this.reload()
  }

  eventClicked = (schedulerData, event) => {
    this.setState({ isModalOpened: true, selectedItem: event })
    // alert(`You just clicked an event: {id: ${event.id}, title: ${event.title}}`)
  }

  eventItemTemplateResolver = (schedulerData, event, bgColor, isStart, isEnd, mustAddCssClass, mustBeHeight, agendaMaxEventWidth) => {
    const titleText = schedulerData.behaviors.getEventTextFunc(schedulerData, event)
    const roundCls = isStart ? (isEnd ? 'round-all' : 'round-head') : (isEnd ? 'round-tail' : 'round-none')
    const divStyle = {
      backgroundColor: bgColor,
      height: mustBeHeight,
      maxWidth: agendaMaxEventWidth,
      color: event.color || '#000000'
    }
    return (
      <div key={event.id} className={`${roundCls} ${mustAddCssClass}`} style={divStyle}>
        <span style={{ marginLeft: '10px', lineHeight: `${mustBeHeight}px` }}>{titleText}</span>
      </div>
    )
  }

  eventItemPopoverTemplateResolver = (schedulerData, eventItem, title, start, end, statusColor) => {
    const {
      /** @var {AuthenticationStore} */
      authenticationStore
    } = this.props
    return (
      <CalendarEvent
        event={eventItem.eventObject}
        address={eventItem.address}
        eventDeleteFunc={this.eventDeleteFunc}
        eventConfirmFunc={this.eventConfirmFunc}
        userRoleCalendar={authenticationStore.getRoleForControllerAction('calendars', ['read_all', 'read_limited', 'read_owner'])}
        userRoleEvents={authenticationStore.getRolesForController('events')}
      />
    )
  }

  handleCloseModal = () => {
    this.setState({ isModalOpened: false, selectedItem: null })
  }

  render () {
    const { viewModel, isModalOpened, selectedItem } = this.state
    const {
      /** @var {AuthenticationStore} */
      authenticationStore
    } = this.props
    if (!viewModel) {
      return <></>
    }
    return (
      <>
        <Header as='h2'>Calendrier</Header>
        <Modal open={isModalOpened} closeIcon onClose={this.handleCloseModal}>
          <Modal.Header>Inspection</Modal.Header>
          <Modal.Content>
            {selectedItem &&
              <CalendarEvent
                event={selectedItem.eventObject}
                address={selectedItem.address}
                eventDeleteFunc={this.eventDeleteFunc}
                eventConfirmFunc={this.eventConfirmFunc}
                userRoleCalendar={authenticationStore.getRoleForControllerAction('calendars', ['read_all', 'read_limited', 'read_owner'])}
                userRoleEvents={authenticationStore.getRolesForController('events')}
              />}
          </Modal.Content>
        </Modal>
        <Scheduler
          schedulerData={viewModel}
          prevClick={this.prevClick}
          nextClick={this.nextClick}
          onSelectDate={this.handleSelectDate}
          onViewChange={this.handleViewChange}
          eventItemClick={this.eventClicked}
          eventItemTemplateResolver={this.eventItemTemplateResolver}
          eventItemPopoverTemplateResolver={this.eventItemPopoverTemplateResolver}
        />
      </>
    )
  }
}

export default CalendarScreen
